export default function SupportInfoContentLayout({children}) {
  return (
    <div className="relative mx-auto max-w-full px-4 py-12 sm:max-w-7xl sm:px-6 sm:py-20 md:py-28 lg:px-8 lg:py-32">
      <div className="md:ml-auto md:w-1/2 md:pl-10">{children}</div>
    </div>
  );
}
